import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './ConfirmDialog.module.scss';

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  message?: string;
  confirmLabel: string;
  cancelLabel?: string;
  loading?: boolean;
  danger?: boolean;
  prompt?: { placeholder?: string };
  onCancel: () => void;
  onConfirm: (value?: string) => void;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  title,
  message,
  confirmLabel,
  cancelLabel,
  loading,
  danger,
  prompt,
  onCancel,
  onConfirm,
}) => {
  const { t } = useTranslation('feedback');
  const [value, setValue] = useState('');

  useEffect(() => {
    if (open) setValue('');
  }, [open]);

  if (!open) return null;

  const confirmDisabled = loading || (!!prompt && !value.trim());

  return (
    <div className={styles.overlay} onClick={loading ? undefined : onCancel}>
      <div className={styles.dialog} onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true">
        <h3 className={styles.title}>{title}</h3>
        {message && <p className={styles.message}>{message}</p>}
        {prompt && (
          <textarea
            className={styles.input}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            placeholder={prompt.placeholder}
            rows={3}
            autoFocus
          />
        )}
        <div className={styles.actions}>
          <button className={styles.cancel} type="button" onClick={onCancel} disabled={loading}>
            {cancelLabel || t('confirm.cancel')}
          </button>
          <button
            className={`${styles.confirm} ${danger ? styles.danger : ''}`}
            type="button"
            onClick={() => onConfirm(prompt ? value.trim() : undefined)}
            disabled={confirmDisabled}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
